import { showPopup } from "./popupVideo";

export function modalButtonHandler() {
  const modalButtons = document.querySelectorAll(".slide-open");

  if (modalButtons.length > 0) {
    modalButtons.forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        // @ts-ignore
        const videoId = this.getAttribute("data-video-id");
        loadVideo(videoId);
        showPopup();
      });
    });
  }
}

function loadVideo(src: string) {
  const videoPlayer = document.getElementById(
    "feedback-player",
  ) as HTMLSourceElement | null;

  if (videoPlayer) {
    videoPlayer.src = src;
    videoPlayer.parentNode.load();
    videoPlayer.parentNode.play();
  } else {
    console.error("Video player element not found.");
  }
}
